import { FC } from "react";
import { BasicProps } from "../types/BasicProps";
import classNames from "classnames";
import Image from "next/image";
import { NetworkConfig } from "config/app.config";

type Props = BasicProps & {
  network: NetworkConfig;
};

const NetworkIcon: FC<Props> = ({ className, network }) => {
  return (
    <div className={classNames("relative", className)}>
      <Image
        className="object-cover h-full"
        src={network.images.srcTertiary}
        alt={network.CHAIN.name}
        fill
      />
    </div>
  );
};

export default NetworkIcon;
